/**
 * Types out multiple strings of texts, one by one.
 * Each string is "displayed" at a rate specified by "typeSpeed."
 * Get the live typewritter feed for the string you want by
 * calling getRevealdText(index) where index is the index
 * number of the string you want.
 *
 * When called from a rendering component, setup your ctx.fillText
 * calls all at once. The strings will draw sequentially with as
 * this component receives update calls from the game engine.
 *
 * Adapted from the textbox code by Luke Willis
 *
 * @author Preston Sia (presia27), Luke Willis
 */
export class MultiLineTypewriter {
    constructor(stringList, typeSpeed = 30) {
        this.currentRevealIndex = [];
        this.elapsedTimes = [];
        this.isRevealing = [];
        this.texts = stringList.slice();
        this.revealSpeed = typeSpeed;
        this.currentTextTrack = 0;
        for (let i = 0; i < this.texts.length; i++) {
            this.currentRevealIndex[i] = 0;
            this.elapsedTimes[i] = 0;
            this.isRevealing[i] = true;
        }
    }
    update(context) {
        const i = this.currentTextTrack;
        if (this.isRevealing[i]) {
            // Update reveal animation
            this.elapsedTimes[i] += context.clockTick;
            const targetIndex = Math.floor(this.elapsedTimes[i] * this.revealSpeed);
            if (targetIndex >= this.texts[i].length) {
                this.currentRevealIndex[i] = this.texts[i].length;
                this.isRevealing[i] = false;
            }
            else {
                this.currentRevealIndex[i] = targetIndex;
            }
        }
        else if (i < this.texts.length) {
            this.currentTextTrack++;
        }
    }
    getRevealedText(index) {
        const text = this.texts[index];
        if (text) {
            return text.substring(0, this.currentRevealIndex[index]);
        }
        else {
            return "???";
        }
    }
    getTextListCount() {
        return this.texts.length;
    }
}
